export const MERCURE_TOPIC_ADMIN_ORDERS = 'admin_orders';

export const MERCURE_TOPIC_ADMIN_CALLS = 'admin_calls';

export const MERCURE_TOPIC_ADMIN_CALLS_HISTORY = 'admin_calls_history';

/**
 * Список топиков Mercure, на которые подписывается админка.
 * Чтобы добавить или убрать топик — правим только этот массив.
 */
export const MERCURE_TOPICS: readonly string[] = [
  MERCURE_TOPIC_ADMIN_ORDERS,
  MERCURE_TOPIC_ADMIN_CALLS,
  MERCURE_TOPIC_ADMIN_CALLS_HISTORY
];
